export default __webpack_public_path__ + "static/media/cover1.ca942d60.png";